import { createSlice } from '@reduxjs/toolkit';
import { calendarApiV4 as api } from 'api';

import { transformFiltersToQuery } from '../utils/transformFilterToQuery';

export const serviceTypeSlice = createSlice({
    name: 'serviceTypeV4',
    initialState: {
        pending: false,
        serviceTypes: [],
        error: null,
        deletePending: false,
        deleteError: null,
        total: 0,
        count: 0,
        currentPage: 1,
        totalPages: 1,
        pendingDownload: false,
    },
    reducers: {
        startDownload: (state, action) => {
            state.pendingDownload = true;
        },
        stopDownload: (state, action) => {
            state.pendingDownload = false;
        },
        start: (state, action) => {
            state.pending = true;
            state.error = null;
        },
        stop: (state, action) => {
            state.pending = false;
        },
        setServiceTypes: (state, action) => {
            state.pending = false;
            state.serviceTypes = action.payload.items;
            state.total = action.payload.total;
            state.count = action.payload.count;
            state.currentPage = action.payload.currentPage;
            state.totalPages = action.payload.totalPages;
        },
        setError: (state, action) => {
            state.pending = false;
            state.error = action.payload;
        },
        addServiceType: (state, action) => {
            state.pending = false;
            state.serviceTypes = [action.payload, ...state.serviceTypes];
        },
        editServiceType: (state, action) => {
            state.pending = false;
            const index = state.serviceTypes.findIndex((serviceType) => serviceType.slug === action.payload.slug);
            if (index !== -1) {
                state.serviceTypes = [
                    ...state.serviceTypes.slice(0, index),
                    action.payload,
                    ...state.serviceTypes.slice(index + 1),
                ];
            }
        },
        deleteServiceType: (state, action) => {
            state.deletePending = false;
            const index = state.serviceTypes.findIndex((serviceType) => serviceType.slug === action.payload.slug);
            if (index !== -1) {
                state.serviceTypes = [...state.serviceTypes.slice(0, index), ...state.serviceTypes.slice(index + 1)];
            }
        },
        startDelete: (state, action) => {
            state.deletePending = true;
        },
        setErrorDelete: (state, action) => {
            state.deletePending = false;
            state.deleteError = action.payload;
        },
    },
});

const {
    start,
    stop,
    setServiceTypes,
    setError,
    addServiceType,
    editServiceType,
    deleteServiceType,
    startDelete,
    setErrorDelete,
    // startDownload,
    // stopDownload,
} = serviceTypeSlice.actions;

export const getServiceTypes = (state) => state.serviceTypeV4.serviceTypes;
export const getServiceTypesPending = (state) => state.serviceTypeV4.pending;
export const getServiceTypeDeletePending = (state) => state.serviceTypeV4.deletePending;
export const getServiceTypesPagination = (state) => ({
    count: state.serviceTypeV4.count,
    currentPage: state.serviceTypeV4.currentPage,
    totalPages: state.serviceTypeV4.totalPages,
    total: state.serviceTypeV4.total,
});

export const fetchServiceTypesAction =
    ({ queryParams, onSuccess, onFailure } = {}) =>
    async (dispatch) => {
        try {
            let query = transformFiltersToQuery(queryParams);
            dispatch(start());
            api.get('service-types' + query)
                .then((response) => {
                    dispatch(setServiceTypes(response.data));
                    if (onSuccess) {
                        onSuccess(response.data);
                    }
                    return response;
                })
                .catch((error) => {
                    dispatch(setError(error));
                    if (onFailure) {
                        onFailure(error);
                    }
                });
        } catch (e) {
            dispatch(stop());
            return console.error(e.message);
        }
    };

export const updateServiceTypeAction =
    ({ id, serviceTypeDto, onSuccess, onFailure }) =>
    async (dispatch) => {
        try {
            api.put('service-types/' + id, serviceTypeDto)
                .then((response) => {
                    dispatch(editServiceType(response.data));
                    onSuccess?.(response.data);
                    return response;
                })
                .catch((error) => {
                    dispatch(stop());
                    onFailure?.();
                });
        } catch (e) {
            dispatch(stop());
            return console.error('error', e);
        }
    };

export const addServiceTypeAction =
    ({ serviceTypeDto, onSuccess, onFailure }) =>
    async (dispatch) => {
        try {
            dispatch(start());
            api.post('service-types', serviceTypeDto)
                .then((response) => {
                    dispatch(addServiceType(response.data));
                    onSuccess?.(response.data);
                    return response;
                })
                .catch((error) => {
                    dispatch(stop());
                    onFailure?.();
                });
        } catch (e) {
            dispatch(stop());
            return console.error(e.message);
        }
    };

export const deleteServiceTypeAction =
    ({ id, onSuccess, onFailure }) =>
    async (dispatch) => {
        try {
            dispatch(startDelete(id));
            api.delete('service-types/' + id)
                .then((response) => {
                    dispatch(deleteServiceType(response.data));
                    onSuccess?.();
                    return response;
                })
                .catch((error) => {
                    dispatch(setErrorDelete(error));
                    onFailure?.(error);
                });
        } catch (e) {
            dispatch(setErrorDelete(e));
            return console.error(e.message);
        }
    };

export default serviceTypeSlice.reducer;
